const AR = require('component/core/index.js');
import {addExcelExport} from 'component/excel-export';
const config = require('./config.yaml');

// Графики, для которых необходимо сформировать табличную легенду
const chartsWithTableLegend = (config.chartsWithTableLegend.length)
	? config.chartsWithTableLegend
	: [];

let chartsWithFewTypeValuesTableLegend = [];
if (config.chartsWithFewTypeValuesTableLegend.length) {
	for (let i in config.chartsWithFewTypeValuesTableLegend) {
		chartsWithFewTypeValuesTableLegend.push(config.chartsWithFewTypeValuesTableLegend[i].id);
	}
}

function getChartWithFewTypeValuesByID(id) {
	let result = false;

	for (let i in config.chartsWithFewTypeValuesTableLegend) {
		if (config.chartsWithFewTypeValuesTableLegend[i].id == id) {
			result = config.chartsWithFewTypeValuesTableLegend[i];
		}
	}

	return result;
}

/**
 * Метод для отрисовки данных легенды в виде таблицы
 * @param items
 */
function buildTableViewLegend(items) {
	const chart = this;

	items
		.html(function (d) {
			return chart.getGroupValues(d).map(function (value) {
				return `<div class="legend__text legend__value">${value || ''}</div>`;
			}).join('\n');
		});
	items.append('div')
		.classed('legend__pict', true)
		.style('min-width', chart.markHeight + 'px')
		.style('min-height', chart.markHeight + 'px')
		.style('background-color', function (d) {
			return chart.getColor(d);
		});
	items.append('p').classed('legend__text', true)
		.html(String);

	let width;
	items.select('.legend__text.legend__value')
		.each(function (selection) {
			width = this.getBoundingClientRect().width;
		});
	// var svg = d3.select($(items.node()).parents('.chart').find('svg')[0]);
	for (let i = 1; i < chart.data.categories.length; i++) {
		chart.svg.append('line')
			.attr({
				x1: width * i,
				y1: chart.options.height,
				x2: width * i,
				y2: chart.options.height - 35,
				class: 'chart__line--gpn'
			});
	}
}

function buildTableViewLegendWithFewValueTypes(items) {
	const chart = this;
	const chartParams = getChartWithFewTypeValuesByID(chart.options.container);
	let $result = $('<div class="legend-table" />');

	let $legendHead = $('<div class="legend-table__head" />');
	for (let i in chartParams['cols']) {
		$('<div/>').appendTo($legendHead)
			.addClass('legend-table__head-item legend-table__head-item--' + i)
			.html(chartParams['cols'][i]['title']);
	}

	let $legendBody = $('<div class="legend-table__body" />');
	items.append('div')
		.classed('legend__pict', true)
		.style('min-width', chart.markHeight + 'px')
		.style('min-height', chart.markHeight + 'px')
		.style('background-color', function (d) {
			return chart.getColor(d);
		});

	items.append('div').classed('legend__text', true)
		.html(String);

	const totalSum = chart.data.layers
		.map(function (a) {
			return parseFloat(a.values);
		}).reduce(function (a, b) {
			return a + b;
		});

	for (let i in items[0]) {
		const $item = $(items[0][i]);
		if (!$item.hasClass('legend__item')) {
			continue;
		}

		const value = $item.find('.legend__text').html();
		let result = '';

		$item
			.find('.legend__pict')
			.wrap('<div class="legend__pict-wrapper"></div>');

		$.each(chart.data.layers, (k, dataItem) => {
			if (dataItem.title == value) {
				for (let n in chartParams['cols']) {
					let col = chartParams['cols'][n];
					let sum1 = '';

					switch (col.type) {
						case 'absolute':
							sum1 = chart.centerFormat(dataItem.values[0]);
							result += `<div class="legend__text legend__value legend__value--${n}">${sum1 || ''}</div>`;
							break;
						case 'percents':
							if (chart.absoluteValues) {
								sum1 = chart.valuesFormat(dataItem.values[0]);
							} else {
								sum1 = chart.valuesFormat(dataItem.values[0] / totalSum);
							}

							result += `<div class="legend__text legend__value">${sum1 || ''}</div>`;
							break;
					}
				}
			}
		});

		if (result) {
			$item.append(result);
		}

		$legendBody.append($item);
	}

	$result.append($legendHead);
	$result.append($legendBody);

	$(`#legend-${(chart.options.container).split('#')[1]}`)
		.empty()
		.append($result);
}

/**
 * Метод инициализации графиков по данным, полученным из charts.json
 * @param callback
 */
function initCharts(callback) {
	require.ensure(['zebra-charts', './charts.json'], function (require) {
		const ZebraCharts = require('zebra-charts');
		const zebraCharts = new ZebraCharts(AR.lang);
		const charts = require('./charts.json');

		charts.filter(chart => chartsWithTableLegend.indexOf(chart.container) > -1)
			.forEach(chart => chart.addElementFunc = buildTableViewLegend);

		charts.filter(chart => chartsWithFewTypeValuesTableLegend.indexOf(chart.container) > -1)
			.forEach(chart => chart.addElementFunc = buildTableViewLegendWithFewValueTypes);


		global.zebraCharts = zebraCharts;
		zebraCharts.makeCharts(charts, callback);
	});
}

/**
 * Инициализация графика по ID его контейнера
 * @param dataContainerID - ID контейнера, по которому мы возьмем данные из конфига
 * @param htmlContainerID - ID контейнера, в который мы пихнем новый график
 * @param callback
 */
function initChartByContainerID(dataContainerID, htmlContainerID = dataContainerID, callback) {
	require.ensure(['zebra-charts', './charts.json'], function (require) {
		const ZebraCharts = require('zebra-charts');
		const zebraCharts = new ZebraCharts(AR.lang);
		global.zebraCharts = zebraCharts;

		const charts = require('./charts.json');
		const needleChart = charts.filter(chart => chart.container == dataContainerID);

		if (needleChart.length) {
			let cloneNeedleChart = JSON.parse(JSON.stringify(needleChart));

			cloneNeedleChart.filter(chart => chartsWithTableLegend.indexOf(chart.container) > -1)
				.forEach(chart => chart.addElementFunc = buildTableViewLegend);

			cloneNeedleChart[0].container = htmlContainerID;
			zebraCharts.makeCharts(cloneNeedleChart, callback);
		}
	});
}

let chartElements = $('.chart');
if (chartElements.length) {
	initCharts(function () {
		$('.graphic').each(function (index, el) {
			let $this = $(this);

			if ($this.find('.chart').length) {
				if (!$this.find('.figure-buttons.js-buttons').length) {
					$this.append('<div class="figure-buttons js-buttons"></div>');
				}

				if (!$this.hasClass('graphic--no-excel')) {
					addExcelExport($this);
				}
			}
		});
	});
}

module.exports.initChartByContainerID = initChartByContainerID;



// WEBPACK FOOTER //
// ./temp/components/charts/index.js